import NestedRouteComponent from 'router/nestedViews/NestedRouteComponent';
import wrapLegacyRoute from 'router/legacy/wrapLegacyRoute';
import translation from 'translation';

const accountSyncRoutes = [
  {
    path: 'sync',
    component: NestedRouteComponent,
    meta: {
      routeName: {
        segmentName: () => translation.tr('Sync sources')
      },
      permissions: ['READ_SYNC_SOURCES']
    },
    children: [
      {
        path: 'sources',
        name: 'syncSourcesList',
        component: wrapLegacyRoute('syncSourcesController', 'list')
      },
      {
        path: 'sources/:sourceId(\\d+)',
        name: 'syncSourceDetails',
        component: wrapLegacyRoute('syncSourcesController', 'details')
      },
      {
        path: 'sources/create',
        name: 'syncSourceCreate',
        component: wrapLegacyRoute('syncSourcesController', 'create')
      }
    ]
  }
];

export default accountSyncRoutes;
